import { Grid, useMediaQuery } from "@material-ui/core";
import Table from "components/Table";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Cell } from "react-table";
import { RootState } from "redux/rootReducer";
import { getReportDateSelector } from "redux/user/user";
import { loadYieldList } from "redux/yieldList/yieldListFunctions";
import { asEur } from "utility/numbers";
import { YieldList } from "types/YieldList";

const YieldListTable = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 960px)");

  const reportControlId = useSelector(
    (state: RootState) => state.user.reportControlId
  );
  const reportDate = useSelector(getReportDateSelector);

  const yieldList = useSelector(
    (state: RootState) => state.yieldList.all?.data ?? []
  );
  const yieldListLoading = useSelector(
    (state: RootState) => state.yieldList.all?.loading
  );

  React.useEffect(() => {
    if (reportControlId && reportDate) {
      dispatch(loadYieldList(reportControlId, reportDate));
    }
  }, [dispatch, reportControlId, reportDate]);

  const yieldListFooterItem = yieldList.find(
    (x) => x.Salkku === "Kokonaistuotto"
  );

  const yieldListColumns = [
    {
      Header: "",
      accessor: "Salkku",
      paddingRight: "10px",
      whiteSpace: "nowrap",
      Footer: yieldListFooterItem?.Salkku ?? "",
    },
    {
      Header: t("start"),
      accessor: "Alusta",
      paddingRight: "10px",
      whiteSpace: "nowrap",
      Cell: (cell: Cell<YieldList, number>) =>
        asEur(cell.value, undefined, true),
      textAlign: "right",
      fontFamily: "Lato light",
      Footer: asEur(yieldListFooterItem?.Alusta, undefined, true),
    },
    {
      Header: t("ytd"),
      accessor: "YTD",
      paddingRight: "10px",
      whiteSpace: "nowrap",
      Cell: (cell: Cell<YieldList, number>) =>
        cell.row.original.Salkku !== "Sijoitettu pääoma"
          ? asEur(cell.value, undefined, true)
          : "",
      textAlign: "right",
      fontFamily: "Lato light",
      Footer: asEur(yieldListFooterItem?.YTD, undefined, true),
    },
    {
      Header: t("month"),
      accessor: "Kuukausi",
      whiteSpace: "nowrap",
      Cell: (cell: Cell<YieldList, number>) =>
        cell.row.original.Salkku !== "Sijoitettu pääoma"
          ? asEur(cell.value, undefined, true)
          : "",
      textAlign: "right",
      fontFamily: "Lato light",
      Footer: asEur(yieldListFooterItem?.Kuukausi, undefined, true),
    },
  ];

  return (
    <Grid
      item
      md={6}
      sm={12}
      style={{
        padding: matchesMediaQuery ? "0 16px 16px 0" : "0 16px 16px 16px",
        overflowY: "hidden",
      }}
    >
      <Table
        data={yieldList.filter((x) => x.Salkku !== "Kokonaistuotto")}
        columns={yieldListColumns}
        hasFooter
        loading={yieldListLoading}
      />
    </Grid>
  );
};

export default React.memo(YieldListTable);
